/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
/*
 * Author M. Atoar Rahman
 * Title: D2Form DataTable
 * Description: D2Form DataTable
 * Date: 30/05/2022
 */
import moment from 'moment';
import { useCallback, useEffect } from 'react';
import { Badge, Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import useAxiosPrivate from '../../../hooks/useAxiosPrivate';
import useDataTable from '../../../hooks/useDataTable';
import UrlService from '../../../services/UrlService';
import { layout } from '../../SvgIcon';
import { useD2Form } from './ContextAPI';
import ToastifyService from '../../../services/ToastifyService';

export default function DataTable() {
    const { d2Forms, getAllData, setRowData, setShowModal, modalLoading, setModalLoading } = useD2Form();
    const axiosPrivate = useAxiosPrivate();

    const dataList = useCallback(() => {
        getAllData();
    }, []);

    useEffect(() => {
        dataList();
    }, [dataList]);

    const showHander = async (row) => {
        if (modalLoading) {
            return;
        }
        setModalLoading(true);
        setShowModal(true);
        setRowData(undefined);
        try {
            const response = await axiosPrivate.get(UrlService.getPartnerD2RecordByIdUrl(row.id), {
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            const row_info = {
                partner_name: row.partner_name,
                month: row.month,
                year: row.year,
                records: response?.data?.d2_record_list,
            };
            setRowData(row_info);
        } catch (err) {
            setShowModal(false);
            setRowData(undefined);
            ToastifyService.errorNotify('Failed to load details!');
            if (!err?.response) {
                console.log('Server Not Responding!');
            } else if (err.response?.status === 401) {
                console.log('Unauthorized!');
            } else {
                console.log('Data Not Found!');
            }
        } finally {
            setModalLoading(false);
        }
    };

    const columns = [
        {
            name: 'Month',
            selector: (row) => row.month,
            cell: (row) =>
                row.month == 1
                    ? 'January'
                    : row.month == 2
                        ? 'February'
                        : row.month == 3
                            ? 'March'
                            : row.month == 4
                                ? 'April'
                                : row.month == 5
                                    ? 'May'
                                    : row.month == 6
                                        ? 'June'
                                        : row.month == 7
                                            ? 'July'
                                            : row.month == 8
                                                ? 'August'
                                                : row.month == 9
                                                    ? 'September'
                                                    : row.month == 10
                                                        ? 'October'
                                                        : row.month == 11
                                                            ? 'November'
                                                            : row.month == 12
                                                                ? 'December'
                                                                : '',
            sortable: true,
        },
        {
            name: 'Year',
            selector: (row) => row.year,
            sortable: true,
        },
        {
            name: 'Submitted Date',
            selector: (row) => row.submitted_date,
            format: (row) => moment(row.submitted_date).format('DD MMM YYYY'),
            sortable: true,
        },
        {
            name: 'Approved Date',
            selector: (row) => row.approval_date,
            format: (row) =>
                row.approval_date ? moment(row.approval_date).format('DD MMM YYYY') : '',
            sortable: true,
        },
        {
            name: 'Status',
            sortable: true,
            cell: (row) =>
                row.status === 'approved' ? (
                    <Badge className="badgeActive" bg="success">
                        Approved
                    </Badge>
                ) : row.status === 'd2_checked' ? (
                    <Badge className="badgeActive" bg="success">
                        D2 Checked
                    </Badge>
                ) : row.status === 'd2_prepared' ? (
                    <Badge className="badgeActive" bg="success">
                        D2 Prepared
                    </Badge>
                ) : row.status === 'final_approved' ? (
                    <Badge className="badgeActive" bg="success">
                        Approved
                    </Badge>
                ) : row.status === 'd2_supplied' ? (
                    <Badge className="badgeActive" bg="success">
                        D2 Supplied
                    </Badge>
                ) : row.status === 'supply_approved' ? (
                    <Badge className="badgeActive" bg="success">
                        Supply Approved
                    </Badge>
                ) : row.status === 'received' ? (
                    <Badge className="badgeActive" bg="success">
                        Received
                    </Badge>
                ) : row.status === 'receive_approved' ? (
                    <Badge className="badgeActive" bg="success">
                        Receive Approved
                    </Badge>
                ) : (
                    <Badge className="badgeInactive" bg="success">
                        Pending
                    </Badge>
                ),
        },
        {
            name: 'Action',
            selector: (row) => row.action,
            cell: (row) => (
                <OverlayTrigger placement="top" overlay={<Tooltip id={`tooltip-view-d2form-${row.id}`}>View</Tooltip>}>
                    <Button
                        onClick={() => showHander(row)}
                        type="button"
                        className="btn btn-light actionBtn"
                        disabled={modalLoading}
                    >
                        {layout}
                    </Button>
                </OverlayTrigger>
            ),
        },
    ];

    return useDataTable({
        columns,
        data: [...d2Forms].sort(
            (a, b) => moment(b.submitted_date).diff(moment(a.submitted_date)) // Descending
        ),
    });
}
